import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, patch, post } from "../../../http/request";

export const searchFlight = createAsyncThunk(
  "flight/search",
  async (
    {
      arrival_id,
      departure_id,
      outbound_date,
      return_date,
      adults,
      children,
      type,
    }: {
      departure_id: string;
      arrival_id: string;
      outbound_date: string;
      return_date: string;
      type: number;
      adults: number;
      children: number;
    },
    thunkAPI
  ) => {
    try {
      const response = await get(
        `/flights/search?engine=google_flights&departure_id=${departure_id}&arrival_id=${arrival_id}&outbound_date=${outbound_date}&return_date=${return_date}&type=${type}&adults=${adults}&children=${children}`
      );
      return response;
    } catch (error: any) {
      const message = error.message.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const searchOneFlight = createAsyncThunk(
  "flight/search-one",
  async (
    {
      arrival_id,
      departure_id,
      id,
      type,
    }: {
      departure_id: string;
      arrival_id: string;
      id: string;
      type: number;
    },
    thunkAPI
  ) => {
    try {
      const response = await get(
        `/flights/${id}?departure_id=${departure_id}&arrival_id=${arrival_id}&type=${type}`
      );
      return response;
    } catch (error: any) {
      const message = error.message.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createBookings = createAsyncThunk(
  "flight/book",
  async (params: object, thunkAPI) => {
    try {
      const response = await post(`/booking/create`, params, {});
      return response;
    } catch (error: any) {
      const message = error.message.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getBookings = createAsyncThunk(
  "bookings/all",
  async (params: string, thunkAPI) => {
    try {
      const response = await get(`/bookings?email=${params}`);
      return response;
    } catch (error: any) {
      const message = error.message.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
